import { defineComponent as _defineComponent } from 'vue'

import { PageState } from "@/constants"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'PageStateError',
  props: {
    state: null,
    resource: null
  },
  setup(__props: any) {



const { router } = useRouter()

return { __sfc: true,router, PageState }
}

})